import appRoutes from './appRoutes';
import apiRoutes from './apiRoutes';
import firebaseRoutes from './firebaseRoutes';
import externalRoutes from './externalRoutes';

export { appRoutes, apiRoutes, firebaseRoutes, externalRoutes };



// WEBPACK FOOTER //
// ./src/routes/index.js